import type { Selection } from "@ui/components/ImagePicker";

/**
 * Maps between the AvatarPicker's `Selection` and the backend `avatar_kind` column. `default` and
 * `custom` are fixed; any other kind is a named character preset (`preset-1`, `preset-2`, …). Shared
 * by the profile settings editor and the account-creator picture stages so both speak the same kinds.
 */
export function avatarKindFromSelection(selection: Selection): string {
  switch (selection.type) {
    case "default":
      return "default";
    case "upload":
      return "custom";
    case "preset":
      return selection.key;
  }
}

export function selectionFromAvatarKind(avatarKind: string): Selection {
  if (avatarKind === "default") return { type: "default" };
  if (avatarKind === "custom") return { type: "upload" };
  return { type: "preset", key: avatarKind };
}
